import Vue from 'vue';
import Vuex from 'vuex';
import request from '@/request/request';
import api from '@/request/api';
Vue.use(Vuex);

const state = {
    token: sessionStorage.getItem('token') ? JSON.parse(sessionStorage.getItem('token')) : '', // 当前登录的token
    localToken: localStorage.getItem('localToken') ? JSON.parse(localStorage.getItem('localToken')) : '', // 自动登录时存在localStorage中的token
    userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
    breadArr: localStorage.getItem('breadArr') ? JSON.parse(localStorage.getItem('breadArr')) : [],
    keepAliveList: [],
    loginState: sessionStorage.getItem('loginState') ? JSON.parse(sessionStorage.getItem('loginState')) : 0 // 用户登录状态
};
const getters = {
    userInfo: state => state.userInfo,
    token: state => state.token, // 当前登录的token
    localToken: state => state.localToken, // 自动登录的token
    breadArr: state => state.breadArr, // 面包屑数组
    loginState: state => state.loginState // 登录状态
};
const mutations = {
    pushKeepAliveList(state, item) {
        let set = new Set(state.keepAliveList);
        set.add(item);
        state.keepAliveList = Array.from(set);
    },
    popKeepAliveList(state, item) {
        let set = new Set(state.keepAliveList);
        if (set.has(item)) {
            set.delete(item);
        }
        state.keepAliveList = Array.from(set);
    },
    setToken(state, data) {
        sessionStorage.setItem('token', JSON.stringify(data));
        state.token = JSON.parse(sessionStorage.getItem('token'));
    },
    setLocalToken(state, data) {
        localStorage.setItem('localToken', JSON.stringify(data));
        state.localToken = JSON.parse(sessionStorage.getItem('localToken'));
    },
    setUserInfo(state, data) {
        // 用户信息
        sessionStorage.setItem('userInfo', JSON.stringify(data));
        state.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    },
    setLoginState(state, data) {
        // 用户信息
        sessionStorage.setItem('loginState', JSON.stringify(data));
        state.loginState = JSON.parse(sessionStorage.getItem('loginState'));
    },
    setBreadArr(state, data) {
        // 添加面包屑记录
        let breads = [{ name: '首页', path: 'Welcome' }];
        breads = breads.concat(data);
        // unshift 从头部添加 pop 从尾部删除
        localStorage.setItem('breadArr', JSON.stringify(breads));
        state.breadArr = JSON.parse(localStorage.getItem('breadArr'));
    },
    pushBreadArr(state, data) {
        // 添加面包屑记录
        let breads = state.breadArr;
        if (breads.length > 2) {
            breads.splice(2, breads.length - 2);
        }
        breads.push(...data);
        localStorage.setItem('breadArr', JSON.stringify(breads));
        state.breadArr = JSON.parse(localStorage.getItem('breadArr'));
    }
};

const actions = {
    upToken({ commit, state }) {
        console.log('commit,state', commit, state);
        let localToken = state.localToken;
        if (localToken != '') {
            commit('setToken', localToken);
        }
    },
    getUserInfo({ commit }) {
        return request.get(api.getUserInfo, {}).then(res => {
            commit('setUserInfo', res);
        });
    },
    getLoginStatus({ commit, dispatch }) {
        return request
            .get(api.getLoginStatus, {})
            .then(result => {
                commit('setLoginState', result.islogin);
                if (result.islogin) {
                    dispatch('getUserInfo');
                }
            })
            .catch(err => {
                console.error('getLoginStatus-err', err);
                commit('setToken', '');
                commit('setUserInfo', '');
            });
    }
};
export default {
    state,
    getters,
    actions,
    mutations
};
